





































































import { Vue, Component } from "vue-property-decorator";
import Bus from "@/common/util/bus";
import store from "@/vuex/index";
import store1 from "@/vuex/modules/login";
import { Public } from "@/http/api_Public";
@Component({
  components: {},
})
export default class SideBar extends Vue {
  public collapsed: boolean = false;
  public admin: boolean = false;
  public userName: string = "";
  public enterpriseLogoImgUrl: string = "";
  curindex = 3;
  isclose = false;

  /**记住的登录信息 */
  loginInfo = {};
  userInfo = {};

  //路由数组
  routerArr = [];

  public async mounted() {
    console.log(232342344234, this.$route.meta.actindex);
    this.routerArr = this.$router.options.routes;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.curindex = this.$route.meta.actindex;
    let res = await Public.GetOnlineIsOpen();
    if(res===true){
      console.log('this.routerArr',this.routerArr);
    }else {
      this.routerArr = this.routerArr.filter(v=>!v.childtype);
      console.log('不是网店this.routerArr',this.routerArr);
    }
  }
  get activeMenu() {
    const route = this.$route;
    const { meta, path } = route;
    if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  }
  get activeIndex() {
    const route = this.$route;
    const { meta, path } = route;
    if (meta.actindex) {
      return meta.actindex;
    }
  }
  openmenu(index) {
    this.isclose = false;
    this.curindex = index;
  }
  closemenu() {
    this.isclose = true;
  }
  // get sycount() {
  //     return this.$store.state.rongCloud.causeAuditCount;
  // }
  // get ylcount() {
  //     return this.$store.state.rongCloud.advanceAuditCount;
  // }
  // get bxcount() {
  //     return this.$store.state.rongCloud.reimburseAuditCount;
  // }
  // get apcount() {
  //     return this.$store.state.rongCloud.advanceToPayCount;
  // }
  // get rpcount() {
  //     return this.$store.state.rongCloud.reimbursementPendingCount;
  // }
  clear() {
    let dayChecked = localStorage.getItem("dayChecked");
    if (dayChecked == "true") {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }
  collapsedfun() {
    this.collapsed = !this.collapsed;
  }
  openIcp() {
    window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/homenew/components/SideBar.vue